
const m = window.require("truth-helpers/helpers/includes");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
